export default __webpack_public_path__ + "static/edit-listing-description-96913cd8b668316b6c7bde3dd97634ca.png";